import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes", "id", "label", "fullWidth", "value"];
import React from "react";
import { Radio } from "informed";
import defaultClasses from "./radio.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
var RadioOption = props => {
  var {
      classes: propClasses,
      id,
      label,
      fullWidth,
      value
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = mergeClasses(defaultClasses, propClasses);
  return /*#__PURE__*/React.createElement("label", {
    className: classes.root,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Radio, _extends({}, rest, {
    className: classes.input,
    id: id,
    value: value
  })), /*#__PURE__*/React.createElement("div", {
    className: "radioLabel ".concat(fullWidth ? defaultClasses.full_width_radio : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, label || (value != null ? value : ""))));
};
export default RadioOption;